module.exports = "<div class=\"g-admin-tabs-content\">\n  <div class=\"g-admin-tabs-pane\">\n    <ng-content></ng-content>\n  </div>\n</div>"